/*eslint no-var: [2] */
import PropTypes from 'prop-types';

import React, { PureComponent } from 'react';

export default class Loader extends PureComponent {
    static defaultProps = {
        message: 'Loading...',
    };

    static propTypes = {
        superStyle: PropTypes.object,
        message: PropTypes.string,
    };

    render() {
        const { superStyle } = this.props;
        return (
            <div className="loading-super" style={superStyle} aria-busy>
                <div className="loading-container">
                    <div className="loading-block">
                        <div className="loading">
                            <h1>{this.props.message}</h1>
                            <span className="ball1" />
                            <span className="ball2" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/loader.jsx